var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, ref } from 'firebase/database';
import mixpanel from '../../config/mixpanelConfig';
import { database } from '../../config/firebaseConfig';
import { _fetchWorkspace, _refreshUserToken, loadUserData, _removeUserFromWorkspace, } from '.';
export var checkUserInvites = createAsyncThunk('user/invites/check', function (_, _a) {
    var getState = _a.getState, dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var user, invitesFound;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    user = getState().user;
                    return [4 /*yield*/, _checkUnassignedUserInvites(user.email, user.id)];
                case 1:
                    invitesFound = _b.sent();
                    if (invitesFound) {
                        dispatch(loadUserData());
                    }
                    return [2 /*return*/, invitesFound];
            }
        });
    });
});
/***  */
var _checkUnassignedUserInvites = function (email, userId) {
    return new Promise(function (resolve, reject) {
        // keys in firebase cannot have periods, therefore
        // change it to a comma
        var emailAsKey = email.replace(/\./g, ',');
        get(ref(database, "workspace-invites/".concat(emailAsKey)))
            .then(function (snapshot) {
            var workspaceIds = snapshot.val();
            if (workspaceIds) {
                _assignUserInvites(userId).then(function (invites) {
                    resolve(invites);
                });
            }
            else {
                resolve(null);
            }
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
};
var _assignUserInvites = function (userId) {
    return new Promise(function (resolve, reject) {
        axios
            .post("/api/user/check-invites", {
            userId: userId,
        })
            .then(function (_a) {
            var data = _a.data;
            var invitesFound = data.payload.invitesFound;
            console.log({ invitesFound: invitesFound });
            resolve(invitesFound);
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
};
export var acceptWorkspaceInvite = createAsyncThunk('user/acceptInvite', function (workspaceId, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var user, promise_workspaceId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    user = getState().user;
                    return [4 /*yield*/, _acceptWorkspaceInvite(workspaceId, user)];
                case 1:
                    promise_workspaceId = _b.sent();
                    mixpanel.track('invite accepted');
                    return [2 /*return*/, promise_workspaceId];
            }
        });
    });
});
export var fetchInvitesDetails = createAsyncThunk('invites/fetchDetails', function (workspaceIds) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, _fetchInvitesDetails(workspaceIds)];
    });
}); });
var _fetchInvitesDetails = function (workspaceIds) {
    return new Promise(function (resolve) {
        var invitesDetails = workspaceIds.map(function (id) {
            return _fetchWorkspace(id).then(function (workspace) {
                return {
                    name: workspace.name,
                    id: id,
                };
            });
        });
        Promise.all(invitesDetails).then(function (result) {
            var composeObject = result.reduce(function (acc, cur) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[cur.id] = cur.name, _a)));
            }, {});
            resolve(composeObject);
        });
    });
};
var _acceptWorkspaceInvite = function (workspaceId, user) {
    return new Promise(function (resolve, reject) {
        axios
            .post("/api/workspace/accept-invite", {
            userId: user.id,
            workspaceId: workspaceId,
        })
            .then(function () {
            _refreshUserToken();
            resolve(workspaceId);
        })
            .catch(function (error) {
            console.log(error);
            reject();
        });
    });
};
export var rejectInvite = createAsyncThunk('user/rejectInvite', function (workspaceId, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var userId, promise;
        return __generator(this, function (_b) {
            userId = getState().user.id;
            promise = _removeUserFromWorkspace(workspaceId, userId).then(function () { return workspaceId; });
            mixpanel.track('invite rejected');
            return [2 /*return*/, promise];
        });
    });
});
